export default __webpack_public_path__ + "static/media/circle-primary.164f4a7d.svg";